import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import AdminOverviewPage from '../pages/admin/AdminOverviewPage';
import BotelManagementPage from '../pages/admin/BotelManagementPage';
import DashboardPage from '../pages/admin/DashboardPage';
import FinancialManagementPage from '../pages/admin/FinancialManagementPage';
import GuestHostManagementPage from '../pages/admin/GuestHostManagementPage';
import MaintenanceOperationsPage from '../pages/admin/MaintenanceOperationsPage';
import SecurityCompliancePage from '../pages/admin/SecurityCompliancePage';
import SystemMonitoringAnalyticsPage from '../pages/admin/SystemMonitoringAnalyticsPage';
import WaitlistManagementPage from '../pages/admin/WaitlistManagementPage';

export const AdminRoutes = [
  <Route 
    key="admin-dashboard" 
    path="/admin/dashboard" 
    element={
      <ProtectedRoute requiredRole="admin">
        <DashboardPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-overview" 
    path="/admin-overview" 
    element={
      <ProtectedRoute requiredRole="admin">
        <AdminOverviewPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-guest-host-management" 
    path="/admin/guest-host-management" 
    element={
      <ProtectedRoute requiredRole="admin">
        <GuestHostManagementPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-botel-management" 
    path="/admin/botel-management" 
    element={
      <ProtectedRoute requiredRole="admin">
        <BotelManagementPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="admin-waitlist-management" 
    path="/admin/waitlist-management" 
    element={
      <ProtectedRoute requiredRole="admin">
        <WaitlistManagementPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="financial-management" 
    path="/financial-management" 
    element={
      <ProtectedRoute requiredRole="admin">
        <FinancialManagementPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="security-compliance" 
    path="/security-compliance" 
    element={
      <ProtectedRoute requiredRole="admin">
        <SecurityCompliancePage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="maintenance-operations" 
    path="/maintenance-operations" 
    element={
      <ProtectedRoute requiredRole="admin">
        <MaintenanceOperationsPage />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="system-monitoring-analytics" 
    path="/system-monitoring-analytics" 
    element={
      <ProtectedRoute requiredRole="admin">
        <SystemMonitoringAnalyticsPage />
      </ProtectedRoute>
    } 
  />
]; 